/** Login del ecosistema (Wompi / Mi Cuenta), no el password de Nest standalone. */
export function shellPublicOrigin() {
  const baked = String(import.meta.env.VITE_SHELL_PUBLIC_URL || '').replace(/\/$/, '');
  if (baked) return baked;
  if (typeof window !== 'undefined' && /localhost|127\.0\.0\.1/.test(window.location.hostname)) {
    return 'http://localhost:3002';
  }
  return 'https://ecosistemafit.app';
}

export function shellConsumerLoginUrl() {
  return `${shellPublicOrigin()}/login?force_logout=1&service=food`;
}

export function shellConsumerFoodAppUrl(path = '/dashboard') {
  const p = String(path || '/dashboard');
  const dest = p.startsWith('/') ? p : `/${p}`;
  return `${shellPublicOrigin()}/food${dest}`;
}

/** Alta Food-only: wizard comercial (Wompi + pendiente de activación). */
export function shellConsumerRegisterUrl() {
  return `${shellPublicOrigin()}/login?register=1&service=food`;
}

/** Host espejo Nest (foodplan.*) — no es el embed /food del ecosistema. */
export function isFoodStandaloneHost() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname.replace(/^www\./, '').toLowerCase();
  if (h.startsWith('foodplan.') || h === 'foodplan.ecosistemafit.app' || h === 'foodplan.tech') {
    return true;
  }
  if (/localhost|127\.0\.0\.1/.test(h) && ['3000', '4173'].includes(String(window.location.port || ''))) {
    return true;
  }
  return false;
}

/** Food embebido en el shell o iframe (no el host foodplan standalone). */
export function isFoodEmbeddedShell() {
  if (isFoodStandaloneHost()) return false;
  if (typeof window !== 'undefined') {
    const p = window.location.pathname || '';
    if (p === '/food' || p.startsWith('/food/') || p === '/food-plan' || p.startsWith('/food-plan/')) {
      return true;
    }
    try {
      if (window.self !== window.top) return true;
    } catch { /* noop */ }
  }
  if (String(import.meta.env.VITE_FOOD_EMBEDDED || '') === 'true') return true;
  if (typeof window === 'undefined') return false;
  try {
    if (localStorage.getItem('d28d_shell') === 'true') return true;
  } catch { /* noop */ }
  return false;
}

/**
 * Destino de «Volver al ecosistema».
 * En foodplan standalone `/` es el dashboard Food (misma sesión USER). Hay que salir de origen.
 */
export function foodReturnToEcosystemHref() {
  if (isFoodEmbeddedShell()) return '/';
  return shellConsumerLoginUrl();
}
